import React, { useEffect } from 'react';
import './index.css';

import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";

function MathOpenEnded() {
    useEffect(() => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ]
            });
        }
    }, []);
    
    return (
        <div className='testFinderMathOpenEnded'>
            <h2 className='testFinderMathOpenEndedHeader'>
                Student-produced response directions
            </h2>
            <ul className='testFinderMathOpenEndedList'>
                <li>If you find <b>more than one correct answer,</b> enter only one answer.</li>
                <li>You can enter up to 5 characters for a <b>positive</b> answer and up to 6 characters (including the negative sign) for a <b>negative</b> answer.</li>
                <li>If your answer is a <b>fraction</b> that doesn't fit in the provided space, enter the decimal equivalent.</li>
                <li>If your answer is a <b>decimal</b> that doesn't fit in the provided space, enter it by truncating or rounding at the fourth digit.</li>
                <li>If your answer is a <b>mixed number</b> (such as <span className='katex'>{`3$\\frac{1}{2}$`}</span>), enter it as an improper fraction (7/2) or its decimal equivalent (3.5).</li>
                <li>Don't enter <b>symbols</b> such as a percent sign, comma, or dollar sign.</li>
            </ul>
            <table className='testFinderMathOpenEndedTable'>
                <tbody>
                    <tr>
                        <th>
                            Answer
                        </th>
                        <th>
                            Acceptable ways to enter answer
                        </th>
                        <th>
                            Unacceptable: will NOT receive credit
                        </th>
                    </tr>
                    <tr>
                        <th>
                            <p className='katex'>{`$3.5$`}</p>
                        </th>
                        <td>
                            <span>3.5</span><br/>
                            <span>3.50</span><br/>
                            <span>7/2</span>
                        </td>
                        <td>
                            <span>31/2</span><br/>
                            <span>3 1/2</span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <p className='katex'>{`$2 \\above{1pt} 3$`}</p>
                        </th>
                        <td>
                            <span>2/3</span><br/>
                            <span>.6666</span><br/>
                            <span>.6667</span><br/>
                            <span>0.666</span><br/>
                            <span>0.667</span>
                        </td>
                        <td>
                            <span>0.66</span><br/>
                            <span>.66</span><br/>
                            <span>0.67</span><br/>
                            <span>.67</span>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            <p className='katex'>{`-$1 \\above{1pt} 3$`}</p>
                        </th>
                        <td>
                            <span>-1/3</span><br/>
                            <span>-.3333</span><br/>
                            <span>-0.333</span>
                        </td>
                        <td>
                            <span>-.33</span><br/>
                            <span>-0.33</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default MathOpenEnded;
